import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const serviceApiConfigApi = createApi({
  reducerPath: "serviceApiConfigApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["serviceApiConfig"],
  endpoints: (build) => ({
    getOrCreateApiKeys: build.query<
      CompanyServiceAPI,
      { companyId: number; serviceId: number }
    >({
      query: ({ companyId, serviceId }) => ({
        url: `/${companyId}/services/${serviceId}/api-config`,
        method: "GET",
      }),
      providesTags: ["serviceApiConfig"],
    }),
    regenerateKey: build.mutation<
      CompanyServiceAPI,
      { companyId: number; serviceId: number }
    >({
      query: ({ companyId, serviceId }) => ({
        url: `/${companyId}/services/${serviceId}/api-config/regen`,
        method: "GET",
      }),
      invalidatesTags: ["serviceApiConfig"],
    }),
    editServiceApi: build.mutation<
      CompanyServiceAPI,
      { companyId: number; serviceId: number; data: ServiceApiData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/api-config`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["serviceApiConfig"],
    }),
  }),
});
